import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, ReactiveFormsModule } from '@angular/forms';


@Component({
  selector: 'app-sobre-mi',
  templateUrl: './sobre-mi.component.html',
  styleUrls: ['./sobre-mi.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule]
})
export class SobreMiComponent implements OnInit {
  private fb = inject(FormBuilder);

  sobreMiForm!: FormGroup;
  mascotaForms!: FormArray;
  lugaresHabitacion: string[] = ["Patio", "Dentro de casa", "Techo", "Todos lados"];

  ngOnInit() {
    this.initSobreMiForm();
  }

  initSobreMiForm() {
    this.sobreMiForm = this.fb.group({
      idRef: ['', Validators.required],
      loQueMasMeGustaHacer: ['', Validators.required],
      misPrincipalesTalentos: ['', Validators.required],
      talentosACompartir: ['', Validators.required],
      experienciaConMascotas: [false],
      sobreMiExperienciaConMascotas: [''],
      numeroMascotas: [0, [Validators.required, Validators.min(0)]],
      tipoMascotas: [''],
      mascotaForms: this.fb.array([])
    });

    this.mascotaForms = this.sobreMiForm.get('mascotaForms') as FormArray;

    this.sobreMiForm.get('numeroMascotas')?.valueChanges.subscribe(value => {
      this.updateMascotaForms(value);
    });
  }

  updateMascotaForms(count: number) {
    this.mascotaForms.clear();
    for (let i = 0; i < count; i++) {
      this.mascotaForms.push(this.createMascotaForm());
    }
  }

  createMascotaForm(): FormGroup {
    return this.fb.group({
      nombre: ['', Validators.required],
      foto: ['', Validators.required],
      adoptado: [false],
      placaIdentificacion: [false],
      vacunacion: ['', Validators.required],
      esterilizacion: [false],
      lugarHabitacion: ['', Validators.required]
    });
  }

  onSubmit() {
    if (this.sobreMiForm.valid) {
      console.log('Form data:', this.sobreMiForm.value);
      // Here you would typically send the data to your backend
    } else {
      console.log('Form is invalid');
    }
  }
}
